module.exports = __webpack_public_path__ + "media/images/icons/arrow-thick-bottom-9a36032486cabdcc3fd096a53e7d4f76.svg";